<template>
  <div class="home">
    <innerHeader v-if="!isMobile" :ind="1"></innerHeader>
    <AppHeader v-if="isMobile" />
    <ResponsiveContainer>
      <div class="main">
        <contentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="2"
          :cloumnId="cloumnId"
          v-if="!isMobile"
          class="bg"
          :detailName="detail.title"
        >
          <div slot="main_content">
            <div class="content_top" v-if="Object.keys(detail).length">
              <div class="article_con">
                <div class="article_l">
                  <img :src="detail.coverImg" />
                  <div class="article_l_title">
                    <p class="presi_title">{{ detail.title }}</p>
                    <p class="presi_actor">
                      {{ detail.digest }}
                    </p>
                  </div>
                </div>
                <div class="article_r">
                  <div class="detail_con" v-html="detail.content"></div>
                  <div class="artical_d">
                    <div class="preArtical" @click="handleArticle(0)">
                      {{ $t('prevPage') }}
                    </div>
                    <div class="nextArtical" @click="handleArticle(1)">
                      {{ $t('nextPage') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="content_top" v-else>
              <el-empty :description="$t('noData')"></el-empty>
            </div>
          </div>
        </contentList>
        <AppcontentList
          :tabList="tabList"
          :leftTab="2"
          :cloumnId="cloumnId"
          v-if="isMobile"
          class="appbg"
        >
          <div slot="main_content">
            <div class="app_content_top" v-if="Object.keys(detail).length">
              <div class="article_con">
                <div class="article_top">
                  <div class="article_l">
                    <img :src="detail.coverImg" />
                  </div>
                  <div class="article_r">
                    <p class="presi_title">{{ detail.title }}</p>
                    <p class="presi_actor">
                      {{ detail.publisher == 'admin' ? '' : detail.publisher }}
                    </p>
                    <p class="presi_actor" v-if="detail.digest">
                      {{ detail.digest }}
                    </p>
                  </div>
                </div>
                <div
                  class="app_detail_con article_dn"
                  v-html="detail.content"
                ></div>
              </div>
            </div>
            <div class="content_top" v-else>
              <el-empty :description="$t('noData')"></el-empty>
            </div></div
        ></AppcontentList>
      </div>
    </ResponsiveContainer>
    <Footer v-if="!isMobile" />
    <AppFooter v-else />
  </div>
</template>

<script>
import innerHeader from '@/components/innerHeader.vue';
import AppHeader from '@/components/AppHeader';
import Footer from '@/components/Footer.vue';
import AppFooter from '@/components/AppFooter';
import ResponsiveContainer from '@/components/ResponsiveContainer';
import contentList from '@/components/contentList';
import AppcontentList from '@/components/AppcontentList';
import paginations from '@/components/Pagination.vue';
import responsiveMixin from '@/mixins/responsiveMixin';
import { presidumTab } from '@/const';
import { getObj, getnextOrUp } from '@/assets/api';
export default {
  name: 'News',
  mixins: [responsiveMixin],
  components: {
    innerHeader,
    AppHeader,
    AppFooter,
    Footer,
    ResponsiveContainer,
    contentList,
    AppcontentList,
    paginations,
  },
  data() {
    return {
      currentIndex: 0,
      tabList: presidumTab,
      cloumnId: null, //栏目id
      detail: {
        name: '陈向宏',
        promoter: true,
        actor: '乌镇戏剧节主席',
        content:
          '<p cms-style="font-L" style="margin-top: 15px; margin-bottom: 15px; font-size: 16px; line-height: 2em; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;; background-color: rgb(255, 255, 255);">这几天空气里终于有了些春天的味道啦！气温回暖，阳光甚好，周末约上了朋友一起自驾去照金春游，是的，我又去照金啦，去不厌的地方，嘿嘿~</p><p cms-style="font-L" style="margin-top: 15px; margin-bottom: 15px; font-size: 16px; line-height: 2em; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;; background-color: rgb(255, 255, 255);">　　从上海自驾到照金大约三个半小时，去了超级梦幻的瑶琳仙境和“小桂林”天目溪漂流，真的很适合现在的天气去游玩，推荐给你们哦！</p><p cms-style="font-L strong-Bold" style="margin-top: 15px; margin-bottom: 15px; font-size: 16px; line-height: 2em; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;; background-color: rgb(255, 255, 255);">　　瑶琳仙境</p><p cms-style="font-L" style="margin-top: 15px; margin-bottom: 15px; font-size: 16px; line-height: 2em; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;; background-color: rgb(255, 255, 255);">　　这是我去过最漂亮的天然溶洞，有一种闯入梦幻地心世界的感觉！里面常年温度在16度，不冷也不热，刚刚好的感觉。</p><div><br></div>',
      },
      articalList: [
        {
          title: '风鹏正举，第十二届乌镇戏剧节青年竞演、古镇嘉年华报名启动！',
          id: 1,
        },
        {
          title: '风鹏正举，第十二届乌镇戏剧节青年竞演、古镇嘉年华报名启动！',
          id: 2,
        },
      ],
      id: '',
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.cloumnId = this.$route.query.cloumnId || null;
    this.getDetail();
  },
  methods: {
    tabChagnge(column, cloumnId) {
      this.cloumnId = cloumnId;
      this.$router.push({ path: column.accessPath });
      // this.getList();
    },
    currentChange(e) {
      this.current = e;
      // this.getList();
    },
    getDetail() {
      getObj(this.id).then((res) => {
        if (res.code == 200) {
          this.detail = res.data;
        }
      });
    },
    handleArticle(next) {
      getnextOrUp({
        columnId: this.cloumnId,
        next,
        sort: this.detail.sortOrder,
      }).then((res) => {
        if (res.code == 200) {
          if (!res.data) {
            if (next == 0) {
              this.$message.warning(this.$t('isFirstPage'));
            } else if (next == 1) {
              this.$message.warning(this.$t('isLastPage'));
            }
          } else {
            this.detail = res.data;
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  .content_top {
    padding: 1.5rem 0;
    .article_con {
      background: #fff;
      display: flex;
      width: 100%;
      box-sizing: border-box;
      border-radius: 0.5rem;
      height: 27.4375rem;
      .article_l {
        width: 17.875rem;
        position: relative;
        img {
          width: 17.875rem;
          height: 100%;
          object-fit: cover;
          border-radius: 0.5rem 0 0 0.5rem;
        }
        .article_l_title {
          position: absolute;
          left: 50%;
          bottom: 0;
          box-sizing: border-box;
          width: 23.125rem;
          height: 5.9375rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: linear-gradient(
            to right,
            rgba(138, 139, 146, 0) 0%,
            rgba(123, 124, 134, 0.5) 30%,
            rgba(107, 109, 122, 1) 50%,
            rgba(169, 169, 169, 0) 100%
          );
          .presi_title {
            margin: 0.625rem 0;
            color: #fff;
            font-size: 1.75rem;
            font-family: SourceHanSansCN-Medium;
            line-height: 2rem;
            text-align: center;
          }
          .presi_actor {
            color: rgba(255, 255, 255, 0.6);
            font-size: 1.25rem;
            text-align: center;
            span {
              margin-left: 0.625rem;
            }
          }
        }
      }
      .article_r {
        flex: 1;
        padding: 2.1875rem 3.125rem 0 2.5rem;
        box-sizing: border-box;
        .artical_d {
          margin-left: auto;
          width: 40%;
          display: flex;
          justify-content: space-between;
          .preArtical {
            width: 48%;
            text-align: left;
            padding-bottom: 0.3333rem;
            border-bottom: 0.1667rem solid;
            border-image: linear-gradient(
                90deg,
                rgba(170, 229, 239, 1),
                rgba(177, 187, 255, 1)
              )
              6 6;
            cursor: pointer;
            &::before {
              content: '';
              display: inline-block;
              width: 0.6667rem;
              height: 0.6667rem;
              border-left: 0.0833rem solid #6b6d7a;
              border-top: 0.0833rem solid #6b6d7a;
              transform: rotate(-45deg);
            }
          }
          .nextArtical {
            width: 48%;
            text-align: right;
            padding-bottom: 0.3333rem;
            border-bottom: 0.1667rem solid;
            border-image: linear-gradient(
                90deg,
                rgba(170, 229, 239, 1),
                rgba(177, 187, 255, 1)
              )
              6 6;
            cursor: pointer;
            &::after {
              content: '';
              display: inline-block;
              width: 0.6667rem;
              height: 0.6667rem;
              border-right: 0.0833rem solid #6b6d7a;
              border-top: 0.0833rem solid #6b6d7a;
              transform: rotate(45deg);
            }
          }
        }
      }
    }
  }
  .app_content_con {
    background: #fff;
  }
  .app_content_top {
    background: #fff;
    // margin: 2rem 0;
    .article_con {
      margin-bottom: 4.1667rem;
      .article_top {
        width: 100vw;
        margin: 3.75rem 0 3.75rem -7.6%;
        background: #6b6d7a;
        height: 12.6667rem;
        display: flex;
        align-items: center;

        .article_l {
          margin-top: -2.0833rem;
          margin-left: 6.4%;
          width: 11.6667rem;
          height: 17.5rem;
          img {
            width: 100%;
            height: 17.5rem;
            object-fit: cover;
          }
        }
        .article_r {
          margin-left: 2rem;
          .presi_title {
            margin: 2rem 0;
            color: #fff;
            font-size: 2rem;
            font-family: SourceHanSansCN-Medium;
            line-height: 2rem;
          }
          .presi_actor {
            color: rgba(255, 255, 255, 0.6);
            font-size: 1.3333rem;
          }
        }
      }
      .article_dn {
      }
    }
  }
}
::v-deep {
  .article_con_in {
    img {
      width: 100% !important;
      height: auto;
    }
  }
  .detail_con {
    height: 16.875rem;
    margin-bottom: 3.125rem;
    overflow-y: scroll;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE/Edge */
    &::-webkit-scrollbar {
      display: none; /* Chrome/Safari/Opera */
    }
    p,
    span,
    strong {
      color: #666 !important;
      font-size: 1.125rem !important;
      font-family: SourceHanSansCN-Normal !important;
      line-height: 2.5rem !important;
    }
  }
}
.appbg {
  width: 100%;
  background: url('../../assets/img/appImg/presi_bg.png') no-repeat left
    bottom/100% auto;
}
.bg {
  width: 100%;
  // background: url('../../assets/img/homeimgs/presi_bg.png') no-repeat left
  //   bottom/100% auto;
  background: url('../../assets/img/homeimgs/presi_bg.png') no-repeat center
    center fixed;
  background-size: cover;
}
</style>
